import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from '../../../../../../ui/toast';
import { getDashboardAssessments } from '../../../../../../utils/api_service/dashboard';
import { AssessmentData } from '../../../../../../utils/types/DashboardTypes';
import { DashboardAssessmentData } from '../../../../DashboardAssessmentTable';

export const useAssessmentTab = (externalSearchTerm?: string) => {
  const history = useHistory();
  const [data, setData] = useState<AssessmentData[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);

  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    const debounceSearchTerm = setTimeout(() => {
      getDashboardAssessments(externalSearchTerm ?? '', pageNumber)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Failed to fetch assessments');
          }
        })
        .then((data: DashboardAssessmentData) => {
          setTotalPages(Math.ceil(data.totalAssessments / 5));
          setData(data.assessments);
          setTotalRecords(data.totalAssessments);
        })
        .catch(() => {
          toast.error('Error Fetching Assessment Data', {
            position: 'bottom-center',
          });
        })
        .finally(() => setLoading(false));
    }, 1000);

    return () => clearTimeout(debounceSearchTerm);
  }, [externalSearchTerm, pageNumber]);

  const handleOnClick = (id: string) => {
    history.push(`/view-assessment/${id}`);
  };

  const onPageChange = (page: number) => {
    setPageNumber(page);
    setLoading(true);
    getDashboardAssessments(externalSearchTerm ?? '', page)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Failed to fetch assessments');
        }
      })
      .then((data: DashboardAssessmentData) => {
        setTotalPages(Math.ceil(data.totalAssessments / 5));
        setData(data.assessments);
      })
      .catch(() => {
        toast.error('Error Fetching Assessment Data', {
          position: 'bottom-center',
        });
      })
      .finally(() => setLoading(false));
  };
  return {
    handleOnClick,
    data,
    setData,
    loading,
    setLoading,
    pageNumber,
    setPageNumber,
    totalPages,
    setTotalPages,
    searchTerm: externalSearchTerm,
    onPageChange,
    totalRecords,
  };
};
